"use client";

export default function TrustMarquee() {
  const items = [
    "✦ Home Nursing Care Kololo",
    "✦ Elderly Care Naguru",
    "✦ Bedside Nursing Nakasero",
    "✦ Wound Care Bugolobi",
    "✦ Medication Management Ntinda",
    "✦ Palliative Care Kampala Uganda",
    "✦ Mobility Support Muyenga",
    "✦ Personal Hygiene Nursing Nalya",
    "✦ End-of-Life Care Munyonyo",
    "✦ Private Home Health Nurse Buziga",
  ];

  return (
    <div
      className="overflow-hidden py-4 border-y"
      style={{
        background: 'linear-gradient(135deg, #0A1F44 0%, #0D2855 100%)',
        borderColor: 'rgba(201,168,76,0.2)'
      }}
      aria-label="Service areas we cover across Kampala"
    >
      <div className="flex">
        <div className="marquee-track">
          {[...items, ...items]?.map((item, i) => (
            <span
              key={`marquee-${i}`}
              className="whitespace-nowrap px-6 text-xs font-medium tracking-widest uppercase font-sans"
              style={{ color: 'rgba(201,168,76,0.7)' }}
            >
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}